import axios from 'axios';

/**
 * Определяем baseURL:
 * - На сервере (SSR): всегда используем полный URL бэкенда
 * - На клиенте: если USE_PROXY=true, используем /api proxy, иначе прямые запросы
 */
const USE_PROXY = process.env.NEXT_PUBLIC_USE_API_PROXY !== 'false';
const isServer = typeof window === 'undefined';

// На сервере относительные пути не работают - нужен полный URL
const getBaseUrl = () => {
  if (isServer) {
    return process.env.NEXT_PUBLIC_API_URL;
  }
  return USE_PROXY ? '/api' : process.env.NEXT_PUBLIC_API_URL;
};

export const api = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
  // withCredentials нужен только для прямых запросов к бэкенду (не через proxy)
  withCredentials: isServer || !USE_PROXY,
});
